import React, { FC } from 'react';
import { Chip, ChipProps, Typography } from '@mui/material';

type Props = { count: number } & Omit<
  ChipProps,
  'label' | 'variant' | 'onDelete'
>;

/**
 * The +N chip that stands in for the applied-filter chips the toolbar could
 * not fit.
 *
 * Trigger props (`bindTrigger`) are spread through so the row can hang its
 * popover off it. It has no ⓧ because it represents several categories, each
 * cleared from its own panel, which is also why it keeps the full 12px of
 * padding on both sides where a chip with a ⓧ gives 4px of it back.
 */
const OverflowCountChip: FC<Props> = ({ count, ...chipProps }) => (
  <Chip
    variant="filter"
    label={
      <Typography component="span" variant="body1" color="grey.900">
        +{count}
      </Typography>
    }
    aria-label={`${count} more applied filters`}
    {...chipProps}
  />
);

export default OverflowCountChip;
